/**
 * Vid2Frames - Main Entry Point (TypeScript + Vite)
 */

import '../css/styles.css';
import '../css/views/home.css';
import { HomeView } from './ts/views/home-view';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => HomeView.init());
} else {
  HomeView.init();
}
